const WORDS = [
  "Specialty coffee",
  "Pay as you use",
  "Johor",
  "The 18 Coffee Roasters",
  "Members' events",
  "Points, not contracts",
];

export const Marquee = () => {
  const loop = [...WORDS, ...WORDS];
  return (
    <section aria-hidden className="border-y border-espresso/10 bg-sand py-8 overflow-hidden">
      <div className="marquee-track">
        {loop.map((w, i) => (
          <span
            key={i}
            className="flex shrink-0 items-center font-display text-5xl font-light tracking-tight text-espresso/70 sm:text-6xl"
          >
            {w}
            <span className="mx-10 text-terracotta">—</span>
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
